import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Nav from "../components/Nav";
import { api, formatApiError } from "../lib/api";
import { EnvelopeSimple } from "@phosphor-icons/react";

export default function CheckEmail() {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const resend = async () => {
    if (!email) return setError("Missing email — go back and register again.");
    setBusy(true);
    setError("");
    setMsg("");
    try {
      await api.post("/auth/resend-verification", { email });
      setMsg("If that account still needs verifying, we sent another link.");
    } catch (e) {
      setError(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <Nav />
      <section className="border-b border-black bg-[color:var(--cc-yellow)]">
        <div className="max-w-md mx-auto px-4 py-16 text-center">
          <EnvelopeSimple size={40} weight="bold" className="mx-auto" />
          <h1 className="font-display font-black text-4xl tracking-tighter mt-4">Check your email</h1>
          <p className="mt-3 text-neutral-800">
            We sent a verification link{email ? <> to <strong>{email}</strong></> : ""}. Open it to activate your account — you can't sign in until then.
          </p>
          {msg && <div className="mt-4 label-tag">{msg}</div>}
          {error && <div className="mt-4 label-tag text-red-600">{error}</div>}
          <div className="mt-8 flex flex-col gap-3">
            <button type="button" disabled={busy || !email} onClick={resend} className="bg-black text-white label-tag px-4 py-4 brutal-btn disabled:opacity-60" data-testid="resend-verification">
              {busy ? "Sending…" : "Resend verification email"}
            </button>
            <Link to="/cardholder/login" className="label-tag underline" data-testid="check-email-login">
              Back to login
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
